import React from "react";

const Footer = () => {
  return (
    <div className=" bg-dark text-white pt-2">
      <div className="container p-4 text-center">
        <h2>Design And Developed By : Sonu kumar </h2>
        <h6>Search There Any  &copy; Cock Drink </h6>
      </div>
    </div>
  );
};

export default Footer;
